import styled from "styled-components";
import { theme } from "./theme";

export const Main = styled.main`
    display: flex;
    flex-direction: column;
    background-color: ${theme.colors.white};
    font-size: 20px;
    @media (max-width: ${theme.breakpoints.tablet}) {
        font-size: 17px;
    }
    @media (max-width: ${theme.breakpoints.mobile}) {
        font-size: 14px;
    }
`;